/*
 * @Author: yinhongwei 
 * @Date: 2021-02-23 17:18:14 
 * @Last Modified by: yinhongwei
 * @Last Modified time: 2023-02-07 21:21:19
 * @Description Notify 消息提示 提示Toast包装组件
 */

import YhwToastAPI from "../components/toast/indexFunction";

 /**
hideOnPress	true	Yes	            控制Toast是否可以在按下时关闭
onPress	none	Yes	                onPressToast按压事件
onLongPress	none	Yes	            Toast长按事件
animated	true	Yes	              控制Toast是否显示动画
animationDuration	225	Yes	        动画持续时间/速度
autoHide	true	                  是控制Toast是否可以在一段时间后隐藏
duration	1850	Yes	              如果autoHide为true，将显示Toast的毫秒数
hideStatusBar	false	Yes	          控制Toast是否将自动隐藏本机状态栏。注意：在iOS中工作正常，并非所有Android版本都支持此功能。
statusBarHeight	none	Yes	        使用此属性设置将添加到Toast填充顶部计算中的自定义状态栏高度
floating	false	Yes	              浮动支柱从边缘松开消息，并将一些边界半径应用于组件
position	top	Yes	                位置道具设置Toast的位置。预期选项：“top”（默认）、“bottom”、“center”或具有｛top、left、right、bottom｝位置的自定义对象
icon	none	Yes	                  图标属性可以是一个渲染函数，它返回一个新的JSX元素，将其放置在图标位置，或者是一个flash消息的图形图标的定义。
                预期选项：“none”（默认）、“auto”（由类型引导）、“success”、“info”、“warning”、“danger”、自定义图标（渲染函数）
                或具有图标类型/名称和位置（左或右）属性的自定义对象，例如：｛icon:“success”，position:“right”｝
style	none	Yes	                  在Toast容器中应用自定义样式对象
textStyle	none	Yes	              在Toast消息 描述/文本标签中应用自定义样式对象
titleStyle	none	Yes	            在Toast消息 标题文本标签中应用自定义样式对象
titleProps	none	Yes	            在Toast消息 标题文本标签中设置自定义props对象
textProps	none	Yes	              在Toast消息 所有文本组件中设置自定义props对象
iconProps	none	Yes	              设置要在renderFlashMessageIcon方法内部使用的自定义props对象作为第三个参数
renderBeforeContent	none	Yes	    在Toast消息 的标题之前呈现自定义JSX。
renderCustomContent	none	Yes	    在Toast消息 的标题下呈现自定义JSX。
renderAfterContent	none	Yes	    在Toast消息 的标题（或描述）之后呈现自定义JSX。
renderFlashMessageIcon	renderFlashMessageIcon	Yes	  为内部消息图标设置自定义渲染函数
transitionConfig	FlashMessageTransition	No	        设置显示/隐藏动画插值中使用的过渡配置函数
canRegisterAsDefault	true	No	                      用于处理实例是否可以注册为默认/全局实例
MessageComponent	DefaultFlash	No	                  设置用于显示所有消息的默认Toast消息呈现组件
  */

/**
 * info消息提示
 * @param {Object} value 提示消息内容，可以字符串，也可对象{}
 * @param {Function} onPress 点击回调事件
 */
function ToastInfo(value, onPress=null) {
  if (!value) return
  let config = {
    message: '',
    type: "info",
    position: "center",
    backgroundColor: "rgba(0,0,0,0.85)",
    duration: 1500,
    onPress: onPress || null
  }
  if (typeof value === "object") { // 自定义配置，进行融合
    config = {...config, ...value}
  } else {
    config.message = value
    config.duration = value.length > 13 ? 2500 : 1500 // 根据内容长度，动态设置显示时间，优化体验
  }

  YhwToastAPI.showMessage(config);
}

/**
 * confirm确认消息提示
 * @param {Object} value 提示消息内容，可以字符串，也可对象{}
 * @param {Function} onPress 点击回调事件
 */
function ToastConfirm(value, onPress=null) {
  if (!value) return
  let config = {
    message: '',
    type: "info",
    position: "center",
    backgroundColor: "rgba(0,0,0,0.85)",
    duration: 3500,
    onPress: onPress || null,
    autoHide: false,
  }
  if (typeof value === "object") { // 自定义配置，进行融合
    config = {...config, ...value}
  } else {
    config.message = value
    config.duration = value.length > 13 ? 2500 : 1500 // 根据内容长度，动态设置显示时间，优化体验
  }

  YhwToastAPI.showMessage(config);
}

/**
 * success消息提示
 * @param {String} value 提示消息内容
 */
function ToastSuccess(value) {
  if (!value) return

  YhwToastAPI.showMessage({
    icon: "success",
    message: value,
    type: "success",
    position: "center",
    backgroundColor: "rgba(0,0,0,0.85)",
    duration: 2500
  });
}

/**
 * warning消息提示
 * @param {String} value 提示消息内容
 */
function ToastWarning(value) {
  if (!value) return

  YhwToastAPI.showMessage({
    icon: "warning",
    message: value,
    type: "warning",
    position: "center",
    backgroundColor: "#000000",
    duration: 2500
  });
}

/**
 * danger消息提示
 * @param {String} value 提示消息内容
 */
function ToastDanger(value) {
  if (!value) return

  YhwToastAPI.showMessage({
    icon: "danger",
    message: value,
    type: "danger",
    position: "center",
    backgroundColor: "#ee0a24",
    duration: 2500
  });
}

const Toast = {
  info: ToastInfo,
  confirm: ToastConfirm,
  success: ToastSuccess,
  warning: ToastWarning,
  danger: ToastDanger,
}

export default Toast